const Mode = {
    CREATE: 'create',
    EDIT: 'edit',
    REACTIVATE: 'reactivate',
    SCHEDULE: 'schedule',
};
export default Mode;
